export default __webpack_public_path__ + "static/media/adminFinochietto1.24f798e1.jpg";